import classNames from "classnames";
import React, { FC } from "react";

import { Flex } from "@/eworkitComponents";
import { PublicAnchor } from "@/router/PublicAnchor";
import { EworkLogo } from "@/views/components/Logo";

import "./_animated-layout-container.scss";

interface IAnimatedLayoutContainerProps {
  size?: "sm" | "md" | "lg";
  showLogo?: boolean;
}

/**
 * @deprecated Use iris-based AnimatedLayoutModal implementation instead.
 */
export const AnimatedLayoutContainer: FC<IAnimatedLayoutContainerProps> = props => {
  const { children, size = "lg", showLogo } = props;

  const baseClass = "animated-layout__container";
  const classes = classNames(baseClass, {
    [`${baseClass}--size-${size}`]: !!size,
  });

  return (
    <div className={classes}>
      {showLogo && (
        <Flex justify="center">
          <PublicAnchor className={`${baseClass}__app-logo-link`} page="">
            <EworkLogo size="xxl" orientation="landscape" />
          </PublicAnchor>
        </Flex>
      )}
      {children}
    </div>
  );
};
